import * as React from 'react';

import { JKAdsBlock } from './jk_ads_block';
import { ContactManagerBlock } from './contact_manager_block';

const s = require('./new_buildings_service_block.css');

interface IProps {
  onAdsClick(eventLabel: string): void;
}

export const NewBuildingsServiceBlock = (props: IProps) =>
  <div className={s['c-selfad-single']}>
    <div className="cg-row">
      <JKAdsBlock/>
      <ContactManagerBlock
          onAdsClick={(label: string) => props.onAdsClick(label)} />
    </div>
  </div>;
